<template>
	<div class="login">
		<div class="cross">
			<a class="link" onclick="window.history.go(-1);">
			<img :src="require('@/assets/cross.png')"/>
			</a>
		</div>
			
		<div class="container-phone" style="padding: 10vh 0;">

			<div class="logo" id="eximuslogin">
				<img :src="require('@/assets/logo_white_small.png')"/>
			</div>

			<div class="pad-l">
				<div class="f-l f-bold c-primary" style="margin: 1em 0">Recupera la Password</div>
				<h2>Inserisci la mail con cui ti sei registrato</h2>
				<div style="margin-top: 0.5em;">
					<form class="form" @submit.prevent="reset_password">
						<div class="p-relative">
							<input type="text" class="text-input" v-model="formData.email" name="email" placeholder="Email" autocomplete="username" required/>
							<div class="icon-md input-icon">email</div>
						</div>

						<br>
						<div style="margin: 0.5em 0;">
								<button type="input" class="submit-button">
									<LoadingWidget class="loading" :class="{hidden: !bLoading}"/>
									<span :class="{hidden: bLoading}">Invia</span>
								</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { notif } from '@/pop'
import api from '@/api'

export default {
	name: 'reset-password',

	data() {

		return {
			// Account email
			formData: {
				email: ''
			},

			// Loading flag
			bLoading: false
		}
	},

	mounted() {

		window.scrollTo(0, 0)
	},

	methods: {
		/**
		 * Attempt login using credentials
		 */
		async reset_password() {
			
			this.bLoading = true

			try
			{
				await api.make('POST', /* endpoint */'/public/reset-password', /* data */{
					email: this.formData.email
				}, /* bJson */true)

				notif.done('Ti abbiamo inviato una mail con la nuova password! Controlla anche nella spam.')
				this.$router.push('login')
			}
			catch (err)
			{
				console.error(err.dev_msg || err)
				notif.error('Nessun account registrato con questa mail!')
			}
			finally
			{
				this.bLoading = false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.cross
	position fixed
	right 20px
	margin-top 20px
	cursor pointer
	transition 0.4s ease
	z-index 9999

.cross img 
		width 1.4em

.logo
	width 144px

	margin 0 auto

	>img
		width 100%

		display block

.form
	.text-input
		width 100%

		display block

		margin 0.5em 0
		padding 0.4em 0.6em
		border none
		outline-color primary
		box-sizing border-box

		background-color dark
		color lightish

		font-size 1.1em

		&:focus
			color light
	
	.input-icon
		position absolute
		right 0.6em
		top 0.4em

		font-size 1.1em
	
	.reset-link
		color cadetblue

		text-decoration none

		&:hover
			text-decoration underline
	
	.submit-button
		width 100%

		display block

		position relative

		padding 0.4em 0.6em
		border none

		background-color primary
		color dark

		font-size: 1.2em

		transition height 0.2s ease

		&:hover
			background-color darken(primary, 2.5)

			cursor pointer
		&:focus
			outline none

		.loading
			width 1.8em
			height 1.8em

			position absolute
			top 50%
			left 50%

			color darkish

			transform translate(-50%, -50%)

			opacity 1

			transition 0.15s ease
		
			&.hidden
				opacity 0
		
		>span
			opacity 1

			transition 0.15s ease

			&.hidden
				opacity 0
</style>